import { useTranslation } from "react-i18next";
import CompleteForm from "../../components/Completepro";

export const CompleteProfile = () => {
  const { t } = useTranslation();

  return (
    <>
      <div id="LoginRoot2">
        <div className="login-top">
          {/* <img src="/site-logo.png" style={{ width: "46%" }} /> */}
          <h1>{t("completepro")}</h1>
        </div>{" "}
        <CompleteForm />
      </div>
    </>
  );
};
